import { HotLead } from '../types/hotLead'

export const hotLeads: HotLead[] = [
  {
    id: 'L-40218',
    name: 'Marcus Delgado',
    loanAmount: 412000,
    seasoningDate: '2024-11-08',
    loanType: 'VA',
    creditPullDate: '2026-08-17',
    stage: 'Contacted',
    disposition: 'Meaningful Conversation',
    estimatedValue: 538000,
    currentRate: 7.125,
    signals: { rateThreshold: true, equity: true, meaningfulConversation: true },
    score: 96,
    urgent: true,
    flaggedAt: '2026-08-20T15:41:00Z',
    touches: [
      {
        sequence: 1,
        channel: 'Direct Mail',
        occurredAt: '2026-08-06T14:00:00Z',
        outcome: 'VA streamline offer mailed',
        owner: 'Campaign',
        connected: false,
      },
      {
        sequence: 2,
        channel: 'Call',
        occurredAt: '2026-08-14T17:12:00Z',
        outcome: 'Inbound from DM — discussed 6.25% target',
        owner: 'Dana Whitlock',
        connected: true,
      },
      {
        sequence: 3,
        channel: 'SMS',
        occurredAt: '2026-08-18T20:04:00Z',
        outcome: 'Sent payment comparison, replied "call me Thu"',
        owner: 'Dana Whitlock',
        connected: true,
      },
    ],
    review: { status: 'pending' },
  },
  {
    id: 'L-40196',
    name: 'Priya Raghunathan',
    loanAmount: 289500,
    seasoningDate: '2025-02-19',
    loanType: 'FHA',
    creditPullDate: '2026-08-19',
    stage: 'App Started',
    disposition: 'Callback Scheduled',
    estimatedValue: 361000,
    currentRate: 6.875,
    signals: { rateThreshold: true, equity: true, meaningfulConversation: true },
    score: 92,
    urgent: true,
    flaggedAt: '2026-08-20T15:22:00Z',
    touches: [
      {
        sequence: 1,
        channel: 'Call',
        occurredAt: '2026-08-11T16:30:00Z',
        outcome: 'MI removal conversation, requested quote',
        owner: 'Rob Castellano',
        connected: true,
      },
      {
        sequence: 2,
        channel: 'Email',
        occurredAt: '2026-08-13T15:02:00Z',
        outcome: 'Sent FHA-to-Conventional comparison',
        owner: 'Rob Castellano',
        connected: false,
      },
      {
        sequence: 3,
        channel: 'Call',
        occurredAt: '2026-08-19T22:15:00Z',
        outcome: 'Callback booked for Aug 21, 10:00',
        owner: 'Rob Castellano',
        connected: true,
      },
    ],
    review: { status: 'pending' },
  },
  {
    id: 'L-40173',
    name: 'Terrence Boyle',
    loanAmount: 505750,
    seasoningDate: '2024-06-30',
    loanType: 'Conventional',
    creditPullDate: '2026-08-14',
    stage: 'Attempting Contact',
    disposition: 'Left Voicemail',
    estimatedValue: 690000,
    currentRate: 7.5,
    signals: { rateThreshold: true, equity: true, meaningfulConversation: false },
    score: 84,
    urgent: false,
    flaggedAt: '2026-08-20T14:58:00Z',
    touches: [
      {
        sequence: 1,
        channel: 'Call',
        occurredAt: '2026-08-12T18:20:00Z',
        outcome: 'No answer',
        owner: 'Dana Whitlock',
        connected: false,
      },
      {
        sequence: 2,
        channel: 'Call',
        occurredAt: '2026-08-17T19:41:00Z',
        outcome: 'Voicemail left',
        owner: 'Dana Whitlock',
        connected: false,
      },
    ],
    review: { status: 'pending' },
  },
  {
    id: 'L-40155',
    name: 'Alicia Nguyen',
    loanAmount: 344000,
    seasoningDate: '2025-05-12',
    loanType: 'VA',
    creditPullDate: '2026-08-18',
    stage: 'Contacted',
    disposition: 'Requested Quote',
    estimatedValue: 402000,
    currentRate: 6.625,
    signals: { rateThreshold: true, equity: false, meaningfulConversation: true },
    score: 79,
    urgent: false,
    flaggedAt: '2026-08-20T14:31:00Z',
    touches: [
      {
        sequence: 1,
        channel: 'SMS',
        occurredAt: '2026-08-15T16:10:00Z',
        outcome: 'Replied asking for rate sheet',
        owner: 'Marisol Vega',
        connected: true,
      },
      {
        sequence: 2,
        channel: 'Call',
        occurredAt: '2026-08-18T17:55:00Z',
        outcome: 'Quoted 6.25%, wants to think it over',
        owner: 'Marisol Vega',
        connected: true,
      },
    ],
    review: { status: 'pending' },
  },
  {
    id: 'L-40142',
    name: 'Hollis Barrett',
    loanAmount: 268900,
    seasoningDate: '2024-09-03',
    loanType: 'FHA',
    creditPullDate: '2026-08-11',
    stage: 'New',
    disposition: 'No Answer',
    estimatedValue: 315000,
    currentRate: 7.25,
    signals: { rateThreshold: true, equity: false, meaningfulConversation: false },
    score: 71,
    urgent: false,
    flaggedAt: '2026-08-20T13:57:00Z',
    touches: [
      {
        sequence: 1,
        channel: 'Direct Mail',
        occurredAt: '2026-08-03T14:00:00Z',
        outcome: 'FHA offer mailed',
        owner: 'Campaign',
        connected: false,
      },
      {
        sequence: 2,
        channel: 'Call',
        occurredAt: '2026-08-10T18:02:00Z',
        outcome: 'No answer',
        owner: 'Marisol Vega',
        connected: false,
      },
      {
        sequence: 3,
        channel: 'Call',
        occurredAt: '2026-08-14T20:33:00Z',
        outcome: 'No answer, no voicemail box',
        owner: 'Marisol Vega',
        connected: false,
      },
      {
        sequence: 4,
        channel: 'SMS',
        occurredAt: '2026-08-19T16:44:00Z',
        outcome: 'No reply',
        owner: 'Marisol Vega',
        connected: false,
      },
    ],
    review: { status: 'pending' },
  },
  {
    id: 'L-40118',
    name: 'Denise Okafor',
    loanAmount: 731000,
    seasoningDate: '2023-12-15',
    loanType: 'Jumbo',
    creditPullDate: '2026-08-16',
    stage: 'Pre-Approved',
    disposition: 'Meaningful Conversation',
    estimatedValue: 985000,
    currentRate: 7.875,
    signals: { rateThreshold: true, equity: true, meaningfulConversation: true },
    score: 94,
    urgent: true,
    flaggedAt: '2026-08-20T13:12:00Z',
    touches: [
      {
        sequence: 1,
        channel: 'Call',
        occurredAt: '2026-08-09T15:20:00Z',
        outcome: 'Cash-out discussion, $180k target',
        owner: 'Rob Castellano',
        connected: true,
      },
      {
        sequence: 2,
        channel: 'Email',
        occurredAt: '2026-08-12T14:05:00Z',
        outcome: 'Docs requested',
        owner: 'Rob Castellano',
        connected: true,
      },
      {
        sequence: 3,
        channel: 'Call',
        occurredAt: '2026-08-16T18:48:00Z',
        outcome: 'Pre-approval issued',
        owner: 'Rob Castellano',
        connected: true,
      },
    ],
    review: {
      status: 'agreed',
      reviewedBy: 'Levi Mahoney',
      reviewedAt: '2026-08-20T13:40:00Z',
    },
  },
  {
    id: 'L-40097',
    name: 'Samuel Reyes',
    loanAmount: 221400,
    seasoningDate: '2025-07-22',
    loanType: 'USDA',
    creditPullDate: '2026-08-09',
    stage: 'Attempting Contact',
    disposition: 'No Answer',
    estimatedValue: 248000,
    currentRate: 6.5,
    signals: { rateThreshold: false, equity: false, meaningfulConversation: false },
    score: 62,
    urgent: false,
    flaggedAt: '2026-08-20T12:44:00Z',
    touches: [
      {
        sequence: 1,
        channel: 'Call',
        occurredAt: '2026-08-08T17:30:00Z',
        outcome: 'No answer',
        owner: 'Dana Whitlock',
        connected: false,
      },
      {
        sequence: 2,
        channel: 'Call',
        occurredAt: '2026-08-13T21:12:00Z',
        outcome: 'Wrong number on file',
        owner: 'Dana Whitlock',
        connected: false,
      },
    ],
    review: {
      status: 'overridden',
      reasonCode: 'EQUITY',
      reasonSubcode: 'Insufficient equity for cash-out',
      reviewedBy: 'Levi Mahoney',
      reviewedAt: '2026-08-20T12:58:00Z',
    },
  },
  {
    id: 'L-40081',
    name: 'Wendy Kaminski',
    loanAmount: 398250,
    seasoningDate: '2024-04-27',
    loanType: 'Conventional',
    creditPullDate: '2026-08-15',
    stage: 'Contacted',
    disposition: 'Callback Scheduled',
    estimatedValue: 512500,
    currentRate: 7.375,
    signals: { rateThreshold: true, equity: true, meaningfulConversation: true },
    score: 90,
    urgent: false,
    flaggedAt: '2026-08-20T12:05:00Z',
    touches: [
      {
        sequence: 1,
        channel: 'Call',
        occurredAt: '2026-08-10T16:00:00Z',
        outcome: 'Discussed removing PMI',
        owner: 'Marisol Vega',
        connected: true,
      },
      {
        sequence: 2,
        channel: 'Call',
        occurredAt: '2026-08-15T19:30:00Z',
        outcome: 'Callback set for next week',
        owner: 'Marisol Vega',
        connected: true,
      },
    ],
    review: {
      status: 'agreed',
      reviewedBy: 'Levi Mahoney',
      reviewedAt: '2026-08-20T12:20:00Z',
    },
  },
  {
    id: 'L-40064',
    name: 'Grant Feliciano',
    loanAmount: 312750,
    seasoningDate: '2024-02-14',
    loanType: 'VA',
    creditPullDate: '2026-07-28',
    stage: 'Attempting Contact',
    disposition: 'No Answer',
    estimatedValue: 388000,
    currentRate: 7.0,
    signals: { rateThreshold: true, equity: true, meaningfulConversation: false },
    score: 68,
    urgent: false,
    flaggedAt: '2026-08-19T21:30:00Z',
    touches: [
      {
        sequence: 1,
        channel: 'Call',
        occurredAt: '2026-08-01T17:05:00Z',
        outcome: 'No answer',
        owner: 'Dana Whitlock',
        connected: false,
      },
      {
        sequence: 2,
        channel: 'Call',
        occurredAt: '2026-08-05T18:22:00Z',
        outcome: 'Voicemail left',
        owner: 'Dana Whitlock',
        connected: false,
      },
      {
        sequence: 3,
        channel: 'Email',
        occurredAt: '2026-08-09T14:10:00Z',
        outcome: 'No open',
        owner: 'Campaign',
        connected: false,
      },
      {
        sequence: 4,
        channel: 'Call',
        occurredAt: '2026-08-16T20:01:00Z',
        outcome: 'No answer — 4th attempt',
        owner: 'Dana Whitlock',
        connected: false,
      },
    ],
    review: {
      status: 'demoted',
      reasonCode: 'TIMING',
      reasonSubcode: '4 touches, no connect — moved to nurture',
      reviewedBy: 'System',
      reviewedAt: '2026-08-19T22:00:00Z',
    },
  },
  {
    id: 'L-40052',
    name: 'Renee Sandoval',
    loanAmount: 187600,
    seasoningDate: '2025-10-01',
    loanType: 'FHA',
    creditPullDate: '2026-07-19',
    stage: 'Contacted',
    disposition: 'Meaningful Conversation',
    estimatedValue: 205000,
    currentRate: 6.25,
    signals: { rateThreshold: false, equity: false, meaningfulConversation: true },
    score: 44,
    urgent: false,
    flaggedAt: '2026-08-19T18:15:00Z',
    touches: [
      {
        sequence: 1,
        channel: 'Call',
        occurredAt: '2026-08-04T16:45:00Z',
        outcome: 'Borrower in Chapter 13, not eligible',
        owner: 'Rob Castellano',
        connected: true,
      },
    ],
    review: {
      status: 'dnq',
      reasonCode: 'DNQ',
      reasonSubcode: 'Bankruptcy / foreclosure',
      reviewedBy: 'Levi Mahoney',
      reviewedAt: '2026-08-19T18:40:00Z',
    },
  },
]
